<app-header ></app-header>
    <div class="container-fluid top-margin">
        <div class="row">
            <div class="panel-left">
            <app-sidemenu></app-sidemenu> 
            <!-- <circle-progress  id="idSpinner"
                [percent]="100"
                [radius]="100"
                [outerStrokeWidth]="16"
                [innerStrokeWidth]="8"
                [outerStrokeColor]="'#78C000'"
                [innerStrokeColor]="'#C7E596'"
                [animation]="true"
                [animationDuration]="10000"
            ></circle-progress> -->
            <!-- <img id="idSpinner" [src]="loadingImage" alt='Loading...' width="100%" class=""/> -->
            </div>
            <div class="sec-middle" class="panel-right">
                
                <app-content>
                    
                </app-content>
                <router-outlet>
                    
                </router-outlet>
            </div>
            </div>
            
    </div>
<!-- <app-footer></app-footer> -->
